const QR_TOKEN_PREFIX = 'qr:'
const CURRENT_HANDLE_KEY = 'qr:currentHandle'
const AUTH_EVENT = 'qr-auth-changed'

const dispatchAuthChange = () => {
  window.dispatchEvent(new Event(AUTH_EVENT))
}

export const normalizeHandle = (handle: string) => handle.trim().toLowerCase()

export const getStoredQrToken = (handle: string) => {
  const normalizedHandle = normalizeHandle(handle)
  return localStorage.getItem(`${QR_TOKEN_PREFIX}${normalizedHandle}`)
}

export const listStoredQrHandles = () => {
  return Object.keys(localStorage)
    .filter((key) => key.startsWith(QR_TOKEN_PREFIX) && key !== CURRENT_HANDLE_KEY)
    .map((key) => key.slice(QR_TOKEN_PREFIX.length))
}

export const getCurrentQrHandle = () => {
  const currentHandle = localStorage.getItem(CURRENT_HANDLE_KEY)
  if (currentHandle && getStoredQrToken(currentHandle)) {
    return currentHandle
  }

  const [firstHandle] = listStoredQrHandles()
  if (firstHandle) {
    localStorage.setItem(CURRENT_HANDLE_KEY, firstHandle)
    return firstHandle
  }

  return null
}

export const setCurrentQrHandle = (handle: string) => {
  const normalizedHandle = normalizeHandle(handle)
  localStorage.setItem(CURRENT_HANDLE_KEY, normalizedHandle)
  dispatchAuthChange()
}

export const saveQrSession = (handle: string, token: string) => {
  const normalizedHandle = normalizeHandle(handle)
  localStorage.setItem(`${QR_TOKEN_PREFIX}${normalizedHandle}`, token)
  localStorage.setItem(CURRENT_HANDLE_KEY, normalizedHandle)
  dispatchAuthChange()
}

export const clearQrSessions = () => {
  listStoredQrHandles().forEach((handle) => {
    localStorage.removeItem(`${QR_TOKEN_PREFIX}${handle}`)
  })
  localStorage.removeItem(CURRENT_HANDLE_KEY)
  dispatchAuthChange()
}

export const qrAuthEventName = AUTH_EVENT
